import { type Client } from 'openapi-fetch'

import { createApiClient, __resetBareApiForTests } from './base-client'
import { authMiddleware } from './middleware/auth'
import {
  networkErrorMiddleware,
  sessionEndedMiddleware,
  subscriptionRequiredMiddleware,
} from './middleware/errors'
import { refreshMiddleware } from './middleware/refresh'
import type { paths } from './generated/schema'

export { unwrap, getBareApi } from './base-client'

/**
 * The typed API client every feature uses.
 *
 * Built on first use rather than at module load. `index.html` loads `/config.js`
 * before the bundle, so a module-level constant would happen to work -- but it
 * would bake the origin in at import time, which makes the load order part of the
 * contract and leaves no way to point the client somewhere else in a test.
 *
 * Middleware order matters and is not the order they run in. `onRequest` runs
 * front to back and `onResponse` back to front, so listing the error handlers
 * first puts them last on the way out -- where they see the response a retried
 * request produced rather than the 401 that provoked the retry.
 */
let client: Client<paths> | null = null

export function getApi(): Client<paths> {
  client ??= createApiClient([
    networkErrorMiddleware,
    sessionEndedMiddleware,
    subscriptionRequiredMiddleware,
    refreshMiddleware,
    authMiddleware,
  ])
  return client
}

/** Drops the memoised clients so the next call rebuilds them from current config. */
export function __resetApiClientForTests(): void {
  client = null
  __resetBareApiForTests()
}
